<template>
  <template v-if="display === 'date' || display === 'time'">
    <div v-if="formattedSingle" v-tooltipable class="truncate text-headline">
      {{ formattedSingle }}
    </div>
    <div v-else data-cy="placeholder">-</div>
  </template>
  <template v-else>
    <div
      v-if="formattedDateTimeArray.length === 2"
      class="flex"
      :class="{ 'flex-col': showTimeBelowDate }"
    >
      <div
        v-tooltipable
        class="truncate"
        :class="showTimeBelowDate ? 'text-label' : 'text-headline'"
        :data-cy="showTimeBelowDate ? 'date' : 'time'"
      >
        {{ formattedDateTimeArray[0] }}
      </div>
      <span v-if="dateTimeDivider">{{ dateTimeDivider }}</span>
      <div
        v-tooltipable
        class="truncate"
        :class="
          showTimeBelowDate
            ? 'text-headline'
            : 'ml-1 truncate whitespace-nowrap text-label'
        "
        :data-cy="showTimeBelowDate ? 'time' : 'date'"
      >
        {{ formattedDateTimeArray[1] }}
      </div>
    </div>
    <div v-else data-cy="placeholder">-</div>
  </template>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { formatDateCustom } from "@/helpers/formatting";

const {
  value,
  showTimeBelowDate = true,
  display = "datetime",
} = defineProps<{
  value: string | null;
  showTimeBelowDate?: boolean;
  display?: "date" | "time" | "datetime";
}>();

const formattedSingle = computed(() => {
  if (!value) {
    return null;
  }

  if (display === "date") {
    // Use formatToUserTimeZone = false for date-only display to show the same
    // calendar date everywhere (avoids off-by-one day issues across timezones)
    return formatDateCustom(value, "MMMM dd, yyyy", false);
  }

  if (display === "time") {
    return formatDateCustom(value, "hh:mm a", true);
  }

  return null;
});

const formattedDateTimeArray = computed(() => {
  if (!value) {
    return [];
  }

  const format = showTimeBelowDate
    ? "MMMM dd, yyyy|hh:mm a"
    : "hh:mm a|MMMM dd, yyyy";

  const formattedDateTime = formatDateCustom(value, format, true);

  return formattedDateTime.split("|");
});

const dateTimeDivider = computed(() => (showTimeBelowDate ? "" : ","));
</script>
